import { NavLink } from 'react-router-dom';
import { PanelLeft, Users, FileText, X, HelpCircle, MessageSquare } from 'lucide-react';
import clsx from 'clsx';
import LOGO from '../../assets/Images/twiggy-logo-transparent.png';

export default function AdminSidebar({ isOpen, setIsOpen, collapsed, toggleCollapse }) {
  return (
    <>
      {/* Mobile backdrop */}
      <div
        className={clsx(
          'fixed inset-0 z-30 bg-black bg-opacity-50 lg:hidden transition-opacity',
          isOpen ? 'block' : 'hidden'
        )}
        onClick={() => setIsOpen(false)}
      />
      
      {/* Sidebar */}
      <div
        className={clsx(
          'fixed z-40 inset-y-0 left-0 bg-black shadow-md transition-all',
          collapsed ? 'w-16 p-2' : 'w-64 p-4',
          'transform lg:translate-x-0 lg:static lg:inset-0',
          isOpen ? 'translate-x-0' : '-translate-x-full',
          'lg:block'
        )}
      >
        <div className="flex flex-col h-full gap-6">
          {/* Logo and Mobile Close */}
          <div className={clsx(
            "flex items-center h-[45px]",
            collapsed ? "justify-center" : "justify-between"
          )}>
            {!collapsed && (
              <div className="flex items-center gap-2">
                <img src={LOGO} alt="Logo" className="block w-[70%] mx-auto" />
              </div>
            )}
            <div className="lg:hidden">
              <X
                className="text-white cursor-pointer"
                onClick={() => setIsOpen(false)}
              />
            </div>
          </div>

          {/* Navigation Menu */}
          <nav className="flex-1 space-y-2">
            <NavLink
              to="/admin/users"
              onClick={() => setIsOpen(false)}
              className={({ isActive }) =>
                clsx(
                  'flex items-center gap-3 px-3 py-3 rounded-md transition-all',
                  'text-white hover:bg-gray-800',
                  isActive && 'bg-gray-800 font-semibold',
                  collapsed && 'justify-center'
                )
              }
            >
              <Users className="w-5 h-5" />
              {!collapsed && <span>Users</span>}
            </NavLink>

            <NavLink
              to="/admin/content"
              onClick={() => setIsOpen(false)}
              className={({ isActive }) =>
                clsx(
                  'flex items-center gap-3 px-3 py-3 rounded-md transition-all',
                  'text-white hover:bg-gray-800',
                  isActive && 'bg-gray-800 font-semibold',
                  collapsed && 'justify-center'
                )
              }
            >
              <FileText className="w-5 h-5" />
              {!collapsed && <span>Contents</span>}
            </NavLink>

            <NavLink
              to="/admin/faq"
              onClick={() => setIsOpen(false)}
              className={({ isActive }) =>
                clsx(
                  'flex items-center gap-3 px-3 py-3 rounded-md transition-all',
                  'text-white hover:bg-gray-800',
                  isActive && 'bg-gray-800 font-semibold',
                  collapsed && 'justify-center'
                )
              }
            >
              <HelpCircle className="w-5 h-5" />
              {!collapsed && <span>FAQs</span>}
            </NavLink>

            <NavLink
              to="/admin/feedback"
              onClick={() => setIsOpen(false)}
              className={({ isActive }) =>
                clsx(
                  'flex items-center gap-3 px-3 py-3 rounded-md transition-all',
                  'text-white hover:bg-gray-800',
                  isActive && 'bg-gray-800 font-semibold',
                  collapsed && 'justify-center'
                )
              }
            >
              <MessageSquare className="w-5 h-5" />
              {!collapsed && <span>Feedback</span>}
            </NavLink>
          </nav>

          {/* Toggle Button at Bottom */}
          <div className="hidden lg:flex justify-start pb-2">
            <PanelLeft
              className="text-white cursor-pointer hover:text-gray-300"
              onClick={toggleCollapse}
            />
          </div>
        </div>
      </div>
    </>
  );
}

